import { createFileRoute } from "@tanstack/react-router";

import ActivationConfirm from "./-components/ActivationConfirm";

export const Route = createFileRoute("/_app/activation/confirm")({
  component: ActivationConfirm,
});
